/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AttachedDocument model module.
 * @module model/AttachedDocument
 * @version 1.0.0
 */
class AttachedDocument {
    /**
     * Constructs a new <code>AttachedDocument</code>.
     * @alias module:model/AttachedDocument
     */
    constructor() { 
        
        AttachedDocument.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AttachedDocument</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AttachedDocument} obj Optional instance to populate.
     * @return {module:model/AttachedDocument} The populated <code>AttachedDocument</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AttachedDocument();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('file_name')) {
                obj['file_name'] = ApiClient.convertToType(data['file_name'], 'String');
            }
            if (data.hasOwnProperty('download_url')) {
                obj['download_url'] = ApiClient.convertToType(data['download_url'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
AttachedDocument.prototype['id'] = undefined;

/**
 * @member {String} file_name
 */
AttachedDocument.prototype['file_name'] = undefined;

/**
 * @member {String} download_url
 */
AttachedDocument.prototype['download_url'] = undefined;






export default AttachedDocument;

